import Session from 'ember-simple-auth/services/session';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed, action } from '@ember/object';
import { getOwner } from '@ember/application';
import { service } from '@ember/service';
import ObjectPromiseProxy from '../helpers/object-promise-proxy';

export default class AppSession extends Session {
  @service requestManager;

  @computed('data.authenticated.user.roles.[]')
  get isAdministrator() {
    return this.data.authenticated?.user?.roles.some(
      (x) => x === 'Administrator',
    ) ?? false;
  }

  @computed('isAdministrator')
  get dashboardVersionPromise() {
    return ObjectPromiseProxy.create({
      promise: this.isAdministrator
        ? this.requestManager
            .request({
              url: '/api/orleans/version',
            })
            .then((response) => response.content)
        : Promise.resolve(null),
    });
  }

  @action refreshAccessToken() {
    const authenticator = getOwner(this).lookup(this.session.authenticator);
    return authenticator._refreshAccessToken(
      this.data.authenticated.expires_in,
      this.data.authenticated.refresh_token,
    );
  }
}
